<template>
  <div>
    <b-breadcrumb
      v-if="pageStatus == '1'"
      style="background-color: #f8f9fa"
    >
      <b-breadcrumb-item to="/dashboard">
        <b-icon
          icon="house-fill"
          scale="1.25"
          shift-v="1.25"
          aria-hidden="true"
        />&nbsp;{{ $t("dashboard") }}
      </b-breadcrumb-item>
      <b-breadcrumb-item active>{{ $t("forms") }}</b-breadcrumb-item>
    </b-breadcrumb>
    <b-breadcrumb
      v-else
      style="background-color: #f8f9fa"
    >
      <b-breadcrumb-item
        v-if="$store.state.selectedTaskType != '/tasks'"
        to="/manage-employee"
      >{{ $t("manageEmployee") }}</b-breadcrumb-item>
      <b-breadcrumb-item :to="$store.state.selectedTaskType">{{ $t("employeeProfile") }}</b-breadcrumb-item>
      <b-breadcrumb-item active>{{ $t("forms") }}</b-breadcrumb-item>
    </b-breadcrumb>
    <AppLoader
      v-if="isLoading"
      class="text-center"
      small
    />
    <div class="m-0">
      <!-- v-if="taskStatus != 0" -->
      <div id="training">
        <b-row class="mb-4 px-5">
          <b-col cols="12">
            <b-card style="height: calc(100vh - 150px);">
              <div
                v-for="(slide,index) in slides"
                :key="index"
              >
                <b-img
                  v-if="currentSlideIndex == index"
                  :src="slide.url"
                  :alt="slide.title"
                  fluid
                  class="text-left animate-slide-from-left"
                  style="height: calc(100vh - 180px);"
                ></b-img>
              </div>
            </b-card>

            <b-row>
              <b-col
                class="text-left"
                cols="5"
              >
                <div class="mt-3">
                  <b-button-group>
                    <b-button
                      variant="warning"
                      v-if="currentSlideIndex > 0"
                      @click="currentSlideIndex = 0"
                    >Go to first slide</b-button>
                    <b-button
                      v-if="isLinkForm && userType == 3"
                      variant="outline-danger"
                      @click="onBack"
                    >Back to Dashboard</b-button>
                    <b-button
                      variant="outline-primary"
                      :disabled="inTransistion"
                      v-if="currentSlideIndex != 0"
                      @click="previousSlide"
                    >Slide {{currentSlideIndex}}</b-button>
                  </b-button-group>
                </div>
              </b-col>
              <b-col
                cols="2"
                class="mt-3"
              >
                <span>
                  Viewing:
                  <b-badge variant="dark">{{(currentSlideIndex+1) +'/'+ (slides.length)}}</b-badge>
                </span>
              </b-col>
              <b-col
                cols="5"
                class="text-right"
              >
                <div class="mt-3">
                  <b-button
                    class="text-right"
                    @click="toggleFullScreen"
                  >
                    <font-awesome-icon icon="compress" />
                  </b-button>
                  <b-button-group>
                    <b-button
                      :disabled="inTransistion"
                      variant="warning"
                      @click="nextslide"
                      v-if="(currentSlideIndex+1) != slides.length"
                    >Next Slide</b-button>
                    <!-- <b-button
                      :disabled="inTransistion"
                      variant="warning"
                      @click="onCompleteTraining"
                      v-if="(currentSlideIndex+1) == slides.length"
                    >Complete</b-button>-->
                    <b-button
                      :disabled="inTransistion"
                      variant="warning"
                      @click="onOpenSignatureModal"
                      v-if="(currentSlideIndex+1) == slides.length"
                    >Next</b-button>
                  </b-button-group>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>

      <!-- <div class="my-5" v-if="taskStatus == 0 && form.isShowFormIntro">
        <h1 class="mb-4">{{formTitle}}</h1>
        <p v-html="sanitizeHtml(pageIntroText)"></p>
        <b-button variant="outline-primary" class="mr-2" @click="onStartTraining">START NOW</b-button>
        <b-button @click="onBack">I'll do it later</b-button>
      </div>-->
    </div>

    <!-- signature modal -->
    <b-modal
      v-model="showSignatureModal"
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop
      modal-header-close="No"
      scrollable
      :title="signatureFormTitle ? signatureFormTitle[selectedLanguage]: ''"
      size="xl"
    >
      <template v-slot:modal-footer>
        <b-button
          variant="outline-danger"
          @click="resetModal"
        >Close</b-button>
        <b-button
          v-if="subTaskStatus != 4"
          @click="onValidateSignature"
        >Complete</b-button>
      </template>
      <div>
        <SignaturePad
          v-if="showSig"
          class="p-5"
          :isPreview="true"
          :fieldData="signatureForm"
          :sectionIndex="0"
          :fieldIndex="1"
          :isDisabled="subTaskStatus == 4 ? 1 : 0 "
        />
      </div>
    </b-modal>
    <b-modal
      id="historyModal"
      cancel-title="Continue"
      ok-title="Start From beginning"
      @ok="startSlidesStart"
      no-close-on-backdrop
      v-model="showModal"
      scrollable
      title="Continue Training"
    >
      <p>Would you like to Continue from slide number {{(currentSlideIndex + 1)}} or start from beginning</p>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions, mapState } from "vuex";
import { sanitizeHtml } from "@/utils/sanitizeHtml";
import SignaturePad from "../../components/templatesConstants/signature";
import AppLoader from "../../components/Loader/Loader";
import _ from "lodash";
import { EventBus } from "@/event-bus.js";
import { HTTP } from "../../utils/HTTP";
import Cryptr from "cryptr";

export default {
  name: "employeeUserTraining",
  components: {
    SignaturePad,
    AppLoader,
  },
  data () {
    return {
      showModal: false,
      isLinkForm: false,
      showSignatureModal: false,
      showSig: false,
      logo: {
        width: "auto",
        height: "50px",
        class: "mt-2",
      },
      isSliding: false,
      inTransistion: false, // set to true when user selects answer and auto navigates to next slide, used to hide or disable buttons
      pageIntroText: null,
      formTitle: null,
      startTraining: false,
      currentSlideIndex: 0,
      currentSlide: null,
      enabled: true,
      dragging: false,
      selected: "english",
      slides: [],
      signatureForm: null,
      isFullScreen: false,

      // stepper functionility
      noOfSteps: 0,
      isCompletedTraining: false,
      imgProps: {
        height: "calc(100% - 150)",
      },
      taskStatus: null,
      linkedForm: null,
      employeeId: null,
      completedTaskIds: [],
      subTaskStatus: 0,
      subTaskId: null,
      signatureFormTitle: null,
      pageStatus: null,
      taskId: null,
      onboardingId: null,
      userType: null,
    };
  },

  mounted () {
    this.$store.state.selectedTaskType = localStorage.getItem( 'selected_task_type' );
    this.userType = localStorage.getItem( "userType" );
    this.$store.state.employeeDashboardTabIndex = 0;
    this.taskId = this.$route.params.taskId;
    this.pageStatus = this.$route.params.readOnly;
    this.checkSlideIndex( this.$route.params.taskId );
  },

  beforeDestroy () {
    // this.onResetLocalData();
    document.removeEventListener( "keydown", event );
  },

  beforeRouteLeave ( to, from, next ) {
    if ( this.fromButton ) {
      next();
    } else {
      const answer = window.confirm(
        "Do you really want to leave? you have unsaved changes!"
      );
      if ( answer ) {
        next();
      } else {
        next( false );
      }
    }
  },

  created () {
    // window.addEventListener("beforeunload", this.leaving);
    let self = this;
    document.addEventListener( "keydown", function ( event ) {
      if (
        self.startTraining &&
        event.which == 39 &&
        self.currentSlideIndex + 1 != self.slides.length
      ) {
        self.nextslide();
      } else if (
        self.startTraining &&
        event.which == 37 &&
        self.currentSlideIndex != 0
      ) {
        self.previousSlide();
      }
    } );
  },

  updated () { },

  watch: {
    // currentSlide () { },
  },

  computed: {
    ...mapGetters( {
      form: "form1",
      selectedLanguage: "selectedLanguage",
      isLoading: "isLoading",
    } ),
    ...mapState( ["selectedAnswersFortrainings"] ),
  },

  methods: {
    sanitizeHtml,
    ...mapActions( ["setLanguage"] ),

    initializeFormData () {
      if ( this.$store.state.getUserFormSubmitArray && this.$store.state.getUserFormSubmitArray.length ) {
        this.$store.state.userFormSubmitArray = this.$store.state.getUserFormSubmitArray;
      } else {
        this.$store.state.userFormSubmitArray = [];
        let tempForm = _.cloneDeep( this.signatureForm );
        this.$store.state.userFormSubmitArray.push( {
          elements: [],
          elementId: this.signatureForm.id,
          elementInputType: this.signatureForm.inputType,
          elementTitle: this.signatureForm.label,
          language: this.selectedLanguage,
        } );
      }
    },

    checkSlideIndex ( id ) {
      this.isLinkForm = true;
      let taskId = localStorage.getItem( "traningTaskId" );
      if ( taskId == id ) {
        this.getTrainingSchema( id );
        return;
      } else {
        localStorage.removeItem( "traningTaskId" );
        this.getTrainingSchema( id );
        return;
      }
    },
    async getTrainingSchema ( id ) {
      let token = "Bearer " + localStorage.getItem( "accessToken" );
      let result = await HTTP(
        "post",
        "api/v1/onboarding/employee/task/detail",
        {
          task_id: id,
        },
        {
          Authorization: token,
        },
        null,
        true
      );
      if ( result.data.status == 1 && result.data.task ) {
        let form = JSON.parse( result.data.task.schema );
        if ( result.data.task.related_form_ids ) {
          let relatedFormIds = JSON.parse( result.data.task.related_form_ids );
          this.employeeId = result.data.task.employee_id;
          if ( relatedFormIds[0] && relatedFormIds[0].formId ) {
            this.linkedForm = relatedFormIds[0];
          }
          this.onboardingId = result.data.task.onboarding_id;
        }
        this.formTitle = form.formTitle[this.selectedLanguage];
        this.formDescription = form.formDescription[this.selectedLanguage];
        this.pageIntroText = form.formIntroText[this.selectedLanguage];
        this.slides = form.formSection[0].formElements[0].files;
        let activeSlideIndex = parseInt(
          localStorage.getItem( "activeSlideIndex" + this.$route.params.taskId )
        );
        if ( activeSlideIndex && activeSlideIndex && activeSlideIndex > 0 ) {
          this.showModal = true;
        }
        if ( activeSlideIndex && activeSlideIndex < this.slides.length ) {
          this.currentSlideIndex = activeSlideIndex;
        }
        this.currentSlide = this.slides[0];
        if ( result.data.task.task_status != 0 ) {
          this.startTraining = true;
        }
        if ( result.data.task.task_status != 4 ) {
          this.onStartTraining();
          this.startTraining = true;
        }
        if(result.data.task.is_active) {
          const cryptr = new Cryptr("myTotalySecretKey");
          const encryptedString = cryptr.encrypt(result.data.task.is_active);
          localStorage.setItem("formStatus", encryptedString);

        }
      }
      localStorage.setItem( "traningTaskId", this.$route.params.taskId );
    },

    startSlidesStart () {
      this.currentSlideIndex = 0;
    },

    onStartTraining () {
      this.startTraining = true;
      if ( this.userType == 1 || this.userType == 2 ) {
        return;
      } else {
        this.updateTaskStatus( 1 );
      }
    },

    leaving () {
      alert( "Leaving..." );
      // window.stop();
    },

    onResetLocalData () {
      localStorage.removeItem( "activeTaskStatus" );
      localStorage.removeItem( "activeFormSchema" );
    },

    autoNextslide () {
      this.inTransistion = true;
      setTimeout( () => {
        this.nextslide();
        this.inTransistion = false;
      }, 1000 );
    },

    onBack () {
      if ( this.pageStatus == "1" ) {
        this.fromButton = true;
        this.$router.push( "/dashboard" );
      } else {
        this.$router.push( this.$store.state.selectedTaskType );
      }
    },

    nextslide () {
      if ( this.currentSlideIndex + 1 < this.slides.length ) {
        this.currentSlideIndex++;
        this.currentslide = this.slides[this.currentSlideIndex];
        localStorage.setItem(
          "activeSlideIndex" + this.$route.params.taskId,
          this.currentSlideIndex
        );
      }
    },

    async updateTaskStatus ( status ) {
      let userId = localStorage.getItem( "userId" );
      let token = "Bearer " + localStorage.getItem( "accessToken" );
      try {
        let result = await HTTP(
          "post",
          "api/v1/governance/training/employee/task/update",
          {
            task_id: this.$route.params.taskId,
            task_status: status,
            user_id: userId,
            form_type: "training",
          },
          {
            Authorization: token,
          },
          null,
          true
        );
        this.taskStatus = status;
      } catch ( error ) {
        return [error];
      }
    },

    previousSlide () {
      this.currentSlideIndex--;
      this.currentslide = this.slides[this.currentSlideIndex];
      localStorage.setItem(
        "activeSlideIndex" + this.$route.params.taskId,
        this.currentSlideIndex
      );
    },

    onOpenSignatureModal () {
      if ( this.linkedForm && this.linkedForm.formId ) {
        this.getFormSchema();
      } else {
        this.onCompleteTraining();
      }
    },

    async getFormSchema () {
      try {
        let result = await HTTP(
          "post",
          "api/v1/governance/training/employee/task/detail",
          {
            formId: this.linkedForm.formId,
            employeeId: this.employeeId,
            onboarding_form_versions_id: this.linkedForm
              .onboarding_form_versions_id,
            onboarding_id: this.onboardingId,
          }
        );
        let linkedForm = JSON.parse( result.data.task.schema );
        this.signatureFormTitle = linkedForm.formTitle;
        this.subTaskStatus = result.data.task.task_status;
        this.subTaskId = result.data.task.id;
        this.signatureForm = linkedForm.formSection[0].formElements[0];
        let form_data =
          typeof result.data.task.form_data == "string"
            ? JSON.parse( result.data.task.form_data )
            : [];
        if (
          form_data &&
          form_data.hasOwnProperty( "user_data" ) &&
          this.subTaskStatus == 4
        ) {
          this.$store.state.getUserFormSubmitArray = form_data.user_data;
        }
        this.initializeFormData();
        this.showSignatureModal = true;
        this.onShowSig();
      } catch ( error ) {
        return [error];
      }
    },

    resetModal () {
      this.showSignatureModal = false;
      this.showSig = false;
    },

    onValidateSignature () {
      EventBus.$emit( "onSubmitEndUserForm", "form training" );
      this.getInvalidFields();
      // this.checkForInValidFields();
    },

    getInvalidFields () {
      if ( this.$store.state.validFields ) {
        this.onSubmitSubTask();
      } else {
        this.showSignatureModal = true;
      }
    },

    async onSubmitSubTask () {
      let userId = localStorage.getItem( "userId" );
      let taskData = this.$store.state.userFormSubmitArray;
      if ( this.taskStatus != 4 || this.subTaskStatus != 4 ) {
        let token = "Bearer " + localStorage.getItem( "accessToken" );

        try {
          let result = await HTTP(
            "post",
            "api/v1/governance/training/employee/task/update",
            {
              task_id: this.subTaskId,
              task_status: 4,
              user_id: userId,
              form_data: taskData,
              form_type: "governance",
            },
            {
              Authorization: token,
            },
            null,
            true
          );
          this.fromButton = true;
          if ( result.data.status == 1 && result.status == 200 ) {
            this.onCompleteTraining();
          }
        } catch ( error ) {
          return [error];
        }
      } else {
        this.fromButton = true;
        // this.$router.push("/dashboard");
        // this.$router.push("dashboard");
      }
    },

    async onCompleteTraining () {
      let userId = localStorage.getItem( "userId" );
      let taskData = this.$store.state.userFormSubmitArray;
      let taskId = localStorage.getItem( "traningTaskId" );
      if ( this.taskStatus != 4 ) {
        let token = "Bearer " + localStorage.getItem( "accessToken" );

        try {
          let result = await HTTP(
            "post",
            "api/v1/governance/training/employee/task/update",
            {
              task_id: taskId,
              task_status: 4,
              user_id: userId,
              form_data: taskData,
              form_type: "training",
            },
            {
              Authorization: token,
            },
            null,
            true
          );
          if ( this.pageStatus == "1" ) {
            this.fromButton = true;
            this.$router.push( "/dashboard" );
          } else {
            this.$router.push( this.$store.state.selectedTaskType );
          }
        } catch ( error ) {
          return [error];
        }
      } else {
        if ( this.pageStatus == "1" ) {
          this.fromButton = true;
          this.$router.push( "/dashboard" );
        } else {
          this.$router.push( this.$store.state.selectedTaskType );
        }
      }
    },

    //method to toggle full screen mood
    toggleFullScreen () {
      if (
        ( document.fullScreenElement && document.fullScreenElement !== null ) ||
        ( !document.mozFullScreen && !document.webkitIsFullScreen )
      ) {
        if ( document.documentElement.requestFullScreen ) {
          document.documentElement.requestFullScreen();
        } else if ( document.documentElement.mozRequestFullScreen ) {
          document.documentElement.mozRequestFullScreen();
        } else if ( document.documentElement.webkitRequestFullScreen ) {
          document.documentElement.webkitRequestFullScreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if ( document.cancelFullScreen ) {
          document.cancelFullScreen();
        } else if ( document.mozCancelFullScreen ) {
          document.mozCancelFullScreen();
        } else if ( document.webkitCancelFullScreen ) {
          document.webkitCancelFullScreen();
        }
      }
    },

    onShowSig () {
      setTimeout( () => {
        this.showSig = true;
      }, 400 );
    },
  },
};
</script>

<style>
.preview-scrollable-wrapper {
  position: relative;
  overflow-y: auto;
  height: calc(100vh - 290px);
  /* height:400px */
}

.selectPicket {
  width: 350px;
}

.animate-slide-from-left {
  position: relative;
  animation: fromLeft 2s;
  opacity: 1;
}

.animate-slide-to-right {
  position: relative;
  animation: toRight 0.5s;
  opacity: 1;
}

@keyframes fromLeft {
  from {
    left: -50px;
    opacity: 0;
  }

  to {
    left: 0;
    opacity: 1;
  }
}

@keyframes toRight {
  from {
    left: 0;
    opacity: 1;
  }

  to {
    left: 150px;
    opacity: 0;
  }
}

.first {
  width: 20rem;
  height: 40px;
  background: #33dd97;
  position: absolute;
}

#talkbubble {
  margin-top: 45px;
  width: 20rem;
  height: 12rem;
  background: #33dd97;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}

#talkbubble:before {
  content: "";
  position: absolute;
  right: 9rem;
  top: 12rem;
  width: 0;
  height: 0;
  border-right: 12px solid transparent;
  border-top: 25px solid #33dd97;
  border-left: 12px solid transparent;
}

.modal-container {
  margin: 5px;
}
</style>
